export { useGetAdDuration } from './useGetAdDuration';
